import { useCallback, useState } from "react";
import { useParams } from "react-router-dom";
import { BoyGate, useBoyInfo } from "@/components/boy/BoyShell";
import { MerchantLogin } from "@/components/boy/portal/MerchantLogin";
import { MerchantHome } from "@/components/boy/portal/MerchantHome";
import { boyToken } from "@/lib/boy";

export default function BoyPortal() {
  const { code } = useParams();
  const [info, err] = useBoyInfo(code);
  const [authed, setAuthed] = useState(() => !!boyToken.get(code));
  const logout = useCallback(() => {
    boyToken.clear(code);
    setAuthed(false);
  }, [code]);
  return (
    <BoyGate info={info} err={err} wide={authed}>
      {authed ? <MerchantHome code={code} onLogout={logout} /> : <MerchantLogin code={code} info={info} onLogged={() => setAuthed(true)} />}
    </BoyGate>
  );
}
